import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { EnterpriseFeatureConfigService } from 'app/services/enterprise-feature-config.service';
import { combineLatest, switchMap, take } from 'rxjs';
//import { ShiftsService } from './pages/admin/services/shifts.services';
import { UserService } from './services/user.service';

export const initialDataResolver = () => {
  const navigationService = inject(NavigationService);
  const enterpriseFeatureConfigService = inject(EnterpriseFeatureConfigService);
  //const shiftsService = inject(ShiftsService);
  const userService = inject(UserService);

  return enterpriseFeatureConfigService.ensureLoaded().pipe(
    switchMap(() =>
      combineLatest([
        navigationService.get(),
        //shiftsService.setupWrapper().pipe(take(1)),
        userService.setupWrapper().pipe(take(1)),
      ])
    )
  );
};
